import { isEmpty } from "lodash";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { authActions } from "@/store/actions";
import { authSelector } from "@/store/auth/auth.slice";
import { ETypeOTP } from "@/types/enum";

import { If } from "../custom/condition";
import { Alert } from "../share/alerts";
import { BaseButton } from "../share/button/BaseButton";
import { BaseInput } from "../share/input";
import { LoginModal } from "./login-modal";
import { useGlobalModal } from "./modal-provider";

export function ModalOtp({ password = "" }: { password?: string }) {
  const dispatch = useDispatch<any>();

  const { errorsValidate, payloadLogin, loadingOtpSend, loadingOtpVerify } =
    useSelector(authSelector);
  const [codeVerification, setCodeVerification] = useState("");

  const { openModal, closeModal } = useGlobalModal();

  const confirm = () => {
    dispatch(
      authActions.otpVerify(
        {
          type: ETypeOTP.Email,
          userId: payloadLogin.userId,
          otpCode: codeVerification,
          scenario: "login",
        },
        (otpToken) => {
          dispatch(authActions.login(otpToken, payloadLogin?.userId, password));
          closeModal();
        }
      )
    );
  };

  const requestLoginAgain = () => {
    dispatch(
      authActions.otpSend(
        {
          type: ETypeOTP.Email,
          userId: payloadLogin.userId,
          scenario: "login",
        },
        () => {}
      )
    );
  };

  const handleCancel = () => {
    openModal({
      title: "Đăng nhập",
      description: "Nhập thông tin tài khoản của bạn bên dưới.",
      body: <LoginModal onSuccess={() => {}} />,
    });
  };

  return (
    <div className="flex flex-col gap-6">
      <If
        condition={!isEmpty(errorsValidate)}
        Then={
          <Alert
            className="bg-error_10"
            messageClass="text-error"
            icon="/icons/info-circle.svg"
            message="Đã có lỗi xảy ra"
          />
        }
      />
      <BaseInput
        value={codeVerification}
        onChange={(e) => setCodeVerification(e?.target?.value)}
        placeholder="Nhập OTP"
        title="Nhập OTP"
      />
      {errorsValidate?.code && (
        <span className="d-block text-danger">{errorsValidate.code}</span>
      )}
      <div className="flex flex-col gap-3 justify-center items-center">
        <BaseButton
          loading={loadingOtpVerify}
          type="button"
          onClick={confirm}
          className="w-full h-10 md:h-12"
        >
          Xác nhận
        </BaseButton>
        <BaseButton
          outline
          className="w-full h-10 md:h-12 bg-white border border-main text-main"
          onClick={handleCancel}
        >
          Hủy bỏ
        </BaseButton>
      </div>
      <div className="flex justify-center">
        <span className="text-sm font-normal text-gray-500">
          Không nhận được mã?
        </span>
        <a
          onClick={() => {
            requestLoginAgain();
          }}
          role="button"
          className={`text-primary hover:text-primary  inline-flex items-center gap-2 no-underline font-bold typography-h6`}
        >
          <span className="text-blue-500 text-sm font-normal">Gửi lại mã</span>
        </a>
      </div>
    </div>
  );
}
